<template>
    <div class="card-box px-6 py-5">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Card',
}
</script>
